import getBaseUri from "get_base_uri";

export const useOLOUrl = () => {
  return getBaseUri();
};
